/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Badge_NewInputs */

const en_portal_badge_new = /** @type {(inputs: Portal_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const pl_portal_badge_new = /** @type {(inputs: Portal_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowość`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Portal_Badge_NewInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_badge_new = /** @type {((inputs?: Portal_Badge_NewInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Badge_NewInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_badge_new(inputs)
	return en_portal_badge_new(inputs)
});